<ion-button color="gray" (click)="addTeam()" fill="outline">
    <span [hidden]="isLoading" style="padding: 5px;">{{'Select' | translate}}</span>
    <ion-spinner [hidden]="!isLoading" name="crescent"></ion-spinner>
</ion-button>